import { FieldValidator } from '../../models/FieldValidator.model';
import { interpretMessage } from '../../utils/interpret-message/interpretMessage';
import { CustomMessageOptions } from '../type';

const MESSAGE = 'Can not be empty';

export function createNonEmptyValidator(
    msgOptions?: CustomMessageOptions,
): FieldValidator {
    return {
        name: 'list.nonEmpty',
        validate: (val?: any[]) => {
            // not checking undeinfed or null they will be part of required
            if (!val) {
                return true;
            }
            if (val.length > 0) {
                return true;
            }

            const message = msgOptions?.customMsg || MESSAGE;
            const params = {
                field: msgOptions?.fieldName || 'field',
                length,
            };

            return interpretMessage(message, params);
        },
    };
}
